export default __webpack_public_path__ + "static/media/franchising-firula.ec21e3b8.svg";